// MUST be the first import so registerLicense runs before any Syncfusion
// module is evaluated. Without it the editor constructor reads an empty
// license and shows the trial banner even when the key is present.
import "@/lib/registerSyncfusion";

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "react-oidc-context";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { initSuiteAppearance } from "@athavita/ui-theme";
import { App } from "./App";
import { initSyncfusion } from "@/lib/syncfusion";
import { installSyncfusionDarkMode } from "@/lib/syncfusionDarkMode";
import { oidcConfig } from "@/auth/authConfig";

import "./styles/globals.css";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false
        }
    }
});

const rootEl = document.getElementById("root");
if (!rootEl) {
    throw new Error("Root element #root not found in index.html");
}

// Belt-and-suspenders — the side-effect import above already registered
// the .env.local key, but this gives us a hook for a backend-fetched
// override in prod without rewiring callers. Same pattern mail-web uses.
void initSyncfusion();
// Suite look (mode, accent, top-bar style) — Docs' own look if it has one.
// Sets `.dark` / data-palette / data-appbar on <html> and follows changes
// made in other Athavita apps.
initSuiteAppearance("docs");
// Ribbon, menus and panes follow `.dark` on <html> (`.e-dark-mode`).
installSyncfusionDarkMode();

ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
        <AuthProvider {...oidcConfig}>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </QueryClientProvider>
        </AuthProvider>
    </React.StrictMode>
);
